import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#213050',
                secondary: '#004cff',
                accent: '#004cff',
                success: '#2e7d32',
                error: '#c62828',
                warning: '#ed6c02',
                info: '#0277bd',
                background: '#f4f6fa'
            }
        }
    }
})
